export default __webpack_public_path__ + "9c7b6d59c61557e84110f25a84bcaeef.png";